import React from 'react'
import { Box, Center, Group, Pagination, ScrollArea, Select, Table as MantineTable, Text, LoadingOverlay, ActionIcon } from '@mantine/core'
import { Sorter } from '../Reports/types'
import { IconArrowNarrowDown, IconArrowNarrowUp } from '@tabler/icons-react'

type TableProps = {
    columns?: {
        text: string
        field_code: string
    }[]
    rows?: any[]
    h?: string | number
    onSort?: (c: any) => void
    rowCount?: string | number
    limit?: number
    page?: number
    setPage?: (page: number) => void
    setLimit?: (limit: string) => void
    onSelect?: (row: any) => void
    sorters?: Sorter[]
    limits?: (string)[]
    loading?: boolean
}

export const Table = ({
    columns = [],
    rows = [],
    h='75vh',
    onSort = () => undefined,
    onSelect = () => undefined,
    rowCount,
    limit,
    page,
    setPage,
    limits = ['10', '25', '50', '75', '100', '200', '500', '1000'],
    setLimit,
    sorters = [],
    loading = false
}: TableProps) => {
    const isSorted = (fieldCode: string) => {
        const sorted = sorters.find(s => s.property === fieldCode)
        if (!sorted) return false
        return sorted.direction
    }
    const setSort = (fieldCode: string) => {
        const sorted = isSorted(fieldCode)
        if (!sorted) {
            onSort({ property: fieldCode, direction: 'DESC' })
        } else {
            onSort({ property: fieldCode, direction: sorted === 'ASC' ? 'DESC' : 'ASC' })
        }
    }

    const maxPages = (Number(rowCount) / Number(limit)) + 1

    return (
        <Box>
            <ScrollArea h={h}>
                <LoadingOverlay visible={loading} />
                <MantineTable style={{ fontSize: 12, overflow: 'none' }} stickyHeader striped highlightOnHover withTableBorder>
                    <MantineTable.Thead>
                        <MantineTable.Tr>
                            {columns.map((c: any) => (
                                <MantineTable.Th key={c.field_code} onClick={() => setSort(c.field_code)} style={{ cursor: 'pointer' }}>
                                        <Group wrap='nowrap' gap={0}>
                                            <Text style={{ verticalAlign: 'center' }}>
                                                {c.text}
                                            </Text>
                                            { !!isSorted(c.field_code) &&
                                            <ActionIcon variant='transparent' mt={10}>
                                                { isSorted(c.field_code) === 'DESC' ?
                                                <IconArrowNarrowUp /> :
                                                <IconArrowNarrowDown />}
                                            </ActionIcon> }
                                        </Group>
                                </MantineTable.Th>
                            ))}
                        </MantineTable.Tr>
                    </MantineTable.Thead>
                    <MantineTable.Tbody>
                        {rows.map((r: any) => (
                            <MantineTable.Tr key={r.report_pk} onClick={() => onSelect(r)}>
                                {columns.map((c: any) => (
                                    <MantineTable.Td key={c.field_code}>
                                        {r[c.field_code]}
                                    </MantineTable.Td>
                                ))}
                            </MantineTable.Tr>
                        ))}
                    </MantineTable.Tbody>
                </MantineTable>
            </ScrollArea>
            { page && limit && rowCount &&
            <Group mt={20} px='md' justify='space-between'>
                <Select w='150' data={limits} allowDeselect={false} value={limit?.toString()} onChange={setLimit} disabled={!setLimit} />
                <Center>
                    <Pagination value={page} onChange={setPage} total={maxPages} defaultValue={page} />
                </Center>
                <Text size='sm'>Displaying Results {((page - 1) * Number(limit)) + 1} - {(page * limit) >= Number(rowCount) ? rowCount : page * limit} of {rowCount}</Text>
            </Group>
            }
        </Box>
    )
}
